export default "__VITE_ASSET__CK7$laqJ__"